import { Stack, Text } from "@mantine/core"
import { Button, SuccessCheckIcon } from "@tfg/ui"
import { useTranslation } from "react-i18next"

type SuccessMessageProps = {
  message: string
  onBack?: () => void
  isLoading: boolean
}

export const SuccessMessage = ({
  message,
  onBack,
  isLoading,
}: SuccessMessageProps) => {
  const { t } = useTranslation("account")

  return (
    <Stack align="center" gap="var(--tfg-molecule-padding-y)">
      <SuccessCheckIcon />
      <Text style={{ textAlign: "center" }}>{message}</Text>
      {onBack && (
        <Button
          size="sm"
          fullWidth={true}
          variant="tertiary"
          disabled={isLoading}
          onClick={onBack}
        >
          {t("login.forgotPassword.back")}
        </Button>
      )}
    </Stack>
  )
}
